/*
 * Nova 3D Print — moteur « Pour toi » (style TikTok)
 * ---------------------------------------------------
 * 1. Signaux : chaque visite de fiche produit (+1), temps passé (+0,5 / 15 s, max +2),
 *    ajout au panier (+3), produit présent dans le panier (+2). Les vieux signaux
 *    s'effacent tout seuls (demi-vie de 3 jours) → les goûts récents comptent plus.
 * 2. Profil : on additionne les tags + type des produits touchés → « centres d'intérêt ».
 * 3. Score de chaque produit du catalogue = affinité avec le profil (pondérée TF-IDF :
 *    un tag rare pèse plus qu'un tag que tout le monde a) + bonus des recommandations
 *    Shopify (Search & Discovery) + petit bonus nouveauté + un peu de hasard.
 * 4. Anti-répétition : produits déjà vus pénalisés, produits du panier exclus,
 *    diversité (pas 8 fois le même type), et X % de « Découverte » hors des goûts.
 * Tout reste dans le navigateur du visiteur (localStorage). Aucune donnée perso.
 *
 * Debug : ajoute ?nfy_debug=1 à l'URL pour voir les scores dans la console.
 * Reset : NovaForYou.reset() dans la console.
 */
(function () {
  'use strict';
  if (window.NovaForYou) { window.NovaForYou.mountAll(); return; }

  var STORE_KEY = 'nova_fy_v1';
  var CAT_KEY = 'nova_fy_cat_v1';
  var CAT_TTL = 20 * 60 * 1000;           // catalogue en cache 20 min
  var HALF_LIFE_H = 72;                   // demi-vie des signaux (heures)
  var MAX_RECORDS = 60;
  var DEBUG = /[?&]nfy_debug=1/.test(location.search);

  var STOP = {};
  ('gift gifts idea ideas 3d printed print made order for and the with to of de du la le les des pour et ' +
   'unique cool acide polylactique plastique bois pla v2 set pack piece').split(' ').forEach(function (w) { STOP[w] = 1; });

  /* ---------- stockage sûr ---------- */
  function load(storage, key) {
    try { var v = storage.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function save(storage, key, val) {
    try { storage.setItem(key, JSON.stringify(val)); } catch (e) { /* mode privé, quota… */ }
  }
  function getState() {
    var s = load(localStorage, STORE_KEY);
    if (!s || typeof s !== 'object' || !s.r) s = { r: {}, v: 1 };
    return s;
  }
  function setState(s) {
    var keys = Object.keys(s.r);
    if (keys.length > MAX_RECORDS) {
      keys.sort(function (a, b) { return s.r[b].t - s.r[a].t; });
      keys.slice(MAX_RECORDS).forEach(function (k) { delete s.r[k]; });
    }
    save(localStorage, STORE_KEY, s);
  }

  /* ---------- signaux ---------- */
  function bump(p, amount, cap) {
    if (!p || !p.handle) return;
    var s = getState();
    var rec = s.r[p.handle] || { id: p.id, ty: p.type || '', tg: [], ti: '', w: 0, t: 0, n: 0 };
    // on « rafraîchit » l'ancien poids avec la décroissance avant d'ajouter
    rec.w = decayed(rec) + amount;
    if (cap) rec.w = Math.min(rec.w, cap);
    rec.t = Date.now();
    rec.n = (rec.n || 0) + (amount >= 1 ? 1 : 0);
    rec.id = p.id || rec.id;
    rec.ty = p.type || rec.ty;
    rec.tg = normTags(p.tags).slice(0, 25);
    rec.ti = (p.title || rec.ti || '').slice(0, 80);
    s.r[p.handle] = rec;
    setState(s);
  }
  function decayed(rec) {
    if (!rec.t) return rec.w || 0;
    var ageH = (Date.now() - rec.t) / 3600000;
    return (rec.w || 0) * Math.pow(0.5, ageH / HALF_LIFE_H);
  }

  /* ---------- caractéristiques (features) ---------- */
  function normTags(tags) {
    if (!tags) return [];
    if (typeof tags === 'string') tags = tags.split(',');
    return tags.map(function (t) { return String(t).trim(); }).filter(Boolean);
  }
  function fold(str) {
    return String(str || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function stem(w) { return (w.length > 4 && /[^s]s$/.test(w)) ? w.slice(0, -1) : w; }
  function features(type, tags, title) {
    var f = {};
    if (type) f['ty:' + fold(type)] = 2;
    var list = normTags(tags);
    var words = [];
    list.forEach(function (tag) {
      var t = fold(tag).replace(/[\s_\-]+/g, '_');
      if (!t || STOP[t]) return;
      f['tg:' + t] = 1.5;
      words = words.concat(t.split(/[^a-z0-9]+/));
    });
    if (!list.length && title) words = words.concat(fold(title).split(/[^a-z0-9]+/));
    words.forEach(function (w) {
      if (w.length < 3 || STOP[w] || /^\d+$/.test(w)) return;
      w = stem(w);
      f['w:' + w] = Math.max(f['w:' + w] || 0, 1);
    });
    return f;
  }

  /* ---------- catalogue ---------- */
  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function getCatalog(root) {
    var key = CAT_KEY + ':' + root;
    var c = load(sessionStorage, key);
    if (c && Date.now() - c.at < CAT_TTL && c.p && c.p.length) return Promise.resolve(c.p);
    var all = [];
    function page(n) {
      return fetchJSON(root + 'products.json?limit=250&page=' + n).then(function (d) {
        var ps = (d && d.products) || [];
        all = all.concat(ps.map(slim));
        if (ps.length === 250 && n < 4) return page(n + 1);
        return all;
      });
    }
    return page(1).then(function (p) { save(sessionStorage, key, { at: Date.now(), p: p }); return p; });
  }
  function slim(p) {
    var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
    var cmp = (p.variants || []).map(function (v) { return parseFloat(v.compare_at_price); }).filter(function (x) { return !isNaN(x); });
    var min = prices.length ? Math.min.apply(null, prices) : null;
    var max = prices.length ? Math.max.apply(null, prices) : null;
    return {
      id: p.id, h: p.handle, ti: p.title, ty: p.product_type || '', tg: normTags(p.tags),
      img: p.images && p.images[0] ? p.images[0].src : '',
      img2: p.images && p.images[1] ? p.images[1].src : '',
      pr: min, var: min !== max, cmp: cmp.length ? Math.max.apply(null, cmp) : null,
      av: (p.variants || []).some(function (v) { return v.available !== false; }),
      at: Date.parse(p.published_at || p.created_at) || 0
    };
  }
  function shopifyRecs(root, productId) {
    if (!productId) return Promise.resolve([]);
    return fetchJSON(root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (d) { return ((d && d.products) || []).map(function (p) { return p.handle; }); })
      .catch(function () { return []; });
  }

  /* ---------- moteur ---------- */
  function rank(ctx, catalog, recLists, local) {
    var s = getState();
    var N = catalog.length || 1;
    // catalogue de base (langue par défaut) = features stables ; catalogue local = affichage
    var base = {};
    catalog.forEach(function (p) { base[p.h] = p; });
    var loc = {};
    (local || []).forEach(function (p) { loc[p.h] = p; });

    // IDF : un tag rare a plus de poids
    var df = {};
    catalog.forEach(function (p) {
      p._f = features(p.ty, p.tg, p.ti);
      Object.keys(p._f).forEach(function (k) { df[k] = (df[k] || 0) + 1; });
    });
    function idf(k) { return Math.log(1 + N / (df[k] || 1)); }

    // profil d'intérêts
    var profile = {}, typeW = {}, total = 0;
    Object.keys(s.r).forEach(function (h) {
      var rec = s.r[h], w = decayed(rec);
      if (w < 0.05) return;
      total += w;
      var b = base[h];
      var f = b ? b._f : features(rec.ty, rec.tg, rec.ti);
      Object.keys(f).forEach(function (k) { profile[k] = (profile[k] || 0) + f[k] * w; });
      var ty = b ? b.ty : rec.ty;
      if (ty) typeW[ty] = (typeW[ty] || 0) + w;
    });
    // le produit courant compte fort (c'est « ce que tu regardes maintenant »)
    if (ctx.product) {
      var cb = base[ctx.product.handle];
      var cf = cb ? cb._f : features(ctx.product.type, ctx.product.tags, ctx.product.title);
      Object.keys(cf).forEach(function (k) { profile[k] = (profile[k] || 0) + cf[k] * 3; });
      total += 3;
    }
    var pmax = 0;
    Object.keys(profile).forEach(function (k) { profile[k] *= idf(k); if (profile[k] > pmax) pmax = profile[k]; });
    var cold = total < 0.5;

    // bonus Shopify (Search & Discovery / algorithme « related » natif)
    var shopBonus = {};
    recLists.forEach(function (list, li) {
      var weight = li === 0 ? 0.8 : 0.5;
      list.forEach(function (h, i) { shopBonus[h] = (shopBonus[h] || 0) + weight * (1 - i / 12); });
    });

    var exclude = {};
    if (ctx.product) exclude[ctx.product.handle] = 1;
    (ctx.cart || []).forEach(function (c) { exclude[c.handle] = 1; });

    var now = Date.now();
    var scored = catalog.filter(function (p) { return !exclude[p.h] && p.img; }).map(function (p) {
      var aff = 0, topK = null, topV = 0;
      if (pmax > 0) {
        Object.keys(p._f).forEach(function (k) {
          if (!profile[k]) return;
          var v = (profile[k] / pmax) * p._f[k] * idf(k);
          aff += v;
          if (k.indexOf('ty:') === 0 && v > topV) { topV = v; topK = k; }
        });
        aff = aff / Math.sqrt(Object.keys(p._f).length || 1); // normalisation longueur
      }
      var sb = shopBonus[p.h] || 0;
      var fresh = (now - p.at) < 30 * 864e5 ? 0.25 : 0;
      var jitter = Math.random() * (cold ? 0.6 : 0.25);
      var score = (cold ? 0 : aff) + sb + fresh + jitter;
      var seen = s.r[p.h];
      if (seen && decayed(seen) > 0.3) score = score * 0.2 - 100; // déjà vu → tout à la fin
      if (!p.av) score *= 0.2;
      var reason = 'aff';
      if (sb > aff && sb > 0.3) reason = 'shop';
      if (seen) reason = 'seen';
      if (fresh && aff < 0.3 && sb < 0.3) reason = 'new';
      return { p: p, score: score, aff: aff, sb: sb, reason: reason, why: topK };
    });

    scored.sort(function (a, b) { return b.score - a.score; });

    // sélection avec diversité + part de découverte
    var out = [], typeCount = {}, pool = scored.slice();
    var exploreEvery = ctx.explore > 0 ? Math.max(2, Math.round(100 / ctx.explore)) : 0;
    var likedTypes = typeW;
    var curBase = ctx.product && base[ctx.product.handle];
    if (curBase && curBase.ty) likedTypes[curBase.ty] = 1;
    else if (ctx.product && ctx.product.type) likedTypes[ctx.product.type] = 1;
    while (pool.length) {
      var slot = out.length + 1;
      var pickIdx = -1;
      if (!cold && exploreEvery && slot % exploreEvery === 0) {
        // découverte : un produit d'un type jamais exploré, pris au hasard dans le haut du panier
        var cands = [];
        pool.forEach(function (x, i) { if (!likedTypes[x.p.ty] && !s.r[x.p.h]) cands.push(i); });
        if (cands.length) {
          pickIdx = cands[Math.floor(Math.random() * Math.min(cands.length, 6))];
          pool[pickIdx].reason = 'explore';
        }
      }
      if (pickIdx < 0) {
        // MMR simplifié : pénaliser un type déjà très présent
        var best = -Infinity;
        for (var i = 0; i < Math.min(pool.length, 25); i++) {
          var x = pool[i];
          var adj = x.score * Math.pow(0.72, typeCount[x.p.ty] || 0);
          if (adj > best) { best = adj; pickIdx = i; }
        }
      }
      var picked = pool.splice(pickIdx, 1)[0];
      typeCount[picked.p.ty] = (typeCount[picked.p.ty] || 0) + 1;
      out.push(picked);
    }

    if (DEBUG) {
      console.groupCollapsed('[NovaForYou] ' + ctx.page + (cold ? ' (démarrage à froid)' : ''));
      console.table(out.slice(0, 24).map(function (x) {
        return { produit: x.p.ti, type: x.p.ty, score: +x.score.toFixed(2), affinite: +x.aff.toFixed(2), shopify: +x.sb.toFixed(2), raison: x.reason, pourquoi: x.why };
      }));
      console.log('Profil (top 15):', Object.keys(profile).sort(function (a, b) { return profile[b] - profile[a]; }).slice(0, 15));
      console.groupEnd();
    }
    // affichage dans la langue du visiteur
    out.forEach(function (x) { if (loc[x.p.h]) x.d = loc[x.p.h]; });
    return { list: out, cold: cold };
  }

  /* ---------- rendu ---------- */
  function money(v, ctx) {
    if (v == null) return '';
    try {
      return new Intl.NumberFormat(ctx.fr ? 'fr-CA' : 'en-CA', { style: 'currency', currency: ctx.currency || 'CAD' }).format(v);
    } catch (e) { return '$' + v.toFixed(2); }
  }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function prettyFeature(k) {
    if (!k) return '';
    var v = k.replace(/^(ty|tg|w):/, '').replace(/_/g, ' ');
    return v.charAt(0).toUpperCase() + v.slice(1);
  }
  function badge(x, ctx) {
    var fr = ctx.fr;
    switch (x.reason) {
      case 'explore': return { t: fr ? 'À découvrir' : 'Discover', c: 'nfy__badge--explore' };
      case 'seen': return { t: fr ? 'Déjà vu' : 'Viewed', c: '' };
      case 'new': return { t: fr ? 'Nouveau' : 'New', c: '' };
      case 'shop': return ctx.product ? { t: fr ? 'Recommandé' : 'Recommended', c: '' } : null;
      default:
        var dty = (x.d || x.p).ty;
        if (x.why && dty && x.aff > 0.4) return { t: (fr ? 'Tu aimes : ' : 'You like: ') + dty, c: '' };
        if (x.aff > 0.4) return { t: fr ? 'Similaire' : 'Similar', c: '' };
        return null;
    }
  }
  function card(x, ctx, idx) {
    var p = x.d || x.p, b = badge(x, ctx);
    var url = ctx.root + 'products/' + encodeURIComponent(p.h);
    var price = p.pr != null ? ((p.var ? (ctx.fr ? 'À partir de ' : 'From ') : '') + money(p.pr, ctx)) : '';
    var cmp = p.cmp && p.pr != null && p.cmp > p.pr ? '<s>' + money(p.cmp, ctx) + '</s>' : '';
    return '<a class="nfy__card" href="' + esc(url) + '" data-nfy-h="' + esc(p.h) + '" style="animation-delay:' + (idx % 12) * 40 + 'ms">' +
      '<div class="nfy__img">' +
        '<img src="' + esc(sized(p.img, 400)) + '" srcset="' + esc(sized(p.img, 300)) + ' 300w, ' + esc(sized(p.img, 500)) + ' 500w, ' + esc(sized(p.img, 800)) + ' 800w" ' +
        'sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(p.ti) + '" loading="lazy" width="500" height="500">' +
        (b ? '<span class="nfy__badge ' + b.c + '">' + esc(b.t) + '</span>' : '') +
      '</div>' +
      '<h3 class="nfy__name">' + esc(p.ti) + '</h3>' +
      '<div class="nfy__price">' + price + cmp + '</div>' +
    '</a>';
  }

  /* ---------- montage d'une section ---------- */
  function mount(el) {
    if (el.__nfy) return;
    el.__nfy = true;
    var ctxEl = el.querySelector('[data-nfy-ctx]');
    var ctx;
    try { ctx = JSON.parse(ctxEl.textContent); } catch (e) { return; }
    ctx.root = ctx.root && ctx.root !== '/' ? ctx.root.replace(/\/?$/, '/') : '/';
    ctx.limit = ctx.limit || 8;

    var grid = el.querySelector('[data-nfy-grid]');
    var moreBtn = el.querySelector('[data-nfy-more]');

    // --- signaux de la page courante ---
    if (ctx.page === 'product' && ctx.product) {
      bump(ctx.product, 1);
      var dwell = 0;
      var timer = setInterval(function () {
        if (document.visibilityState !== 'visible') return;
        dwell++;
        bump(ctx.product, 0.5);
        if (dwell >= 4) clearInterval(timer);
      }, 15000);
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (f && f.action && /\/cart\/add/.test(f.action)) bump(ctx.product, 3);
      }, true);
    }
    if (ctx.page === 'cart' && ctx.cart && ctx.cart.length) {
      var s = getState();
      ctx.cart.forEach(function (c) {
        var r = s.r[c.handle];
        if (!r || Date.now() - r.t > 6 * 3600000) bump(c, 2);
      });
    }

    // --- recommandations Shopify pour ancrer le fil ---
    var st = getState();
    var recent = Object.keys(st.r).map(function (h) { return st.r[h]; })
      .sort(function (a, b) { return b.t - a.t; });
    var anchors = [];
    if (ctx.product) anchors.push(ctx.product.id);
    (ctx.cart || []).forEach(function (c) { if (anchors.length < 3) anchors.push(c.id); });
    recent.forEach(function (r) { if (anchors.length < 3 && r.id && anchors.indexOf(r.id) < 0) anchors.push(r.id); });

    Promise.all([
      getCatalog('/'),
      Promise.all(anchors.map(function (id) { return shopifyRecs(ctx.root, id); })),
      ctx.root !== '/' ? getCatalog(ctx.root).catch(function () { return null; }) : null
    ]).then(function (res) {
      var ranked = rank(ctx, res[0], res[1], res[2]);
      var list = ranked.list;
      if (!list.length) { el.closest('.nfy-section, section, .shopify-section').hidden = true; return; }
      var shown = 0;
      function render(n) {
        var html = '';
        list.slice(shown, shown + n).forEach(function (x, i) { html += card(x, ctx, i); });
        if (shown === 0) grid.innerHTML = html; else grid.insertAdjacentHTML('beforeend', html);
        shown = Math.min(list.length, shown + n);
        if (moreBtn) moreBtn.hidden = shown >= list.length;
      }
      render(ctx.limit);
      if (moreBtn) moreBtn.addEventListener('click', function () { render(ctx.limit); });
      // clic sur une reco = petit signal positif (l'intérêt se confirme à la visite)
      grid.addEventListener('click', function (e) {
        var a = e.target.closest('[data-nfy-h]');
        if (!a) return;
        var h = a.getAttribute('data-nfy-h');
        var item = list.filter(function (x) { return x.p.h === h; })[0];
        if (item) bump({ id: item.p.id, handle: h, type: item.p.ty, tags: item.p.tg, title: item.p.ti }, 0.3);
      });
    }).catch(function (err) {
      if (DEBUG) console.warn('[NovaForYou] erreur', err);
      var sec = el.closest('.shopify-section');
      if (sec) sec.hidden = true;
    });
  }

  function mountAll() {
    document.querySelectorAll('[data-nfy]').forEach(mount);
  }

  window.NovaForYou = {
    mountAll: mountAll,
    reset: function () { try { localStorage.removeItem(STORE_KEY); Object.keys(sessionStorage).forEach(function (k) { if (k.indexOf(CAT_KEY) === 0) sessionStorage.removeItem(k); }); } catch (e) {} console.log('NovaForYou: profil effacé'); },
    profile: function () { return getState(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();
  // éditeur de thème Shopify : re-monter quand une section est ajoutée/rechargée
  document.addEventListener('shopify:section:load', mountAll);
})();
